  <div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{title}}</span>
          <button mat-icon-button class="mat-icon-button white-fg"
                  (click)="dialogRef.close()"
                  aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <app-user-selection
        [users] = "users"
        [selectedUsers] = "selectedUsers"
        [readOnly]="!allowEdit"
        (onChanged) = "selectedUsersChanged($event)"
    ></app-user-selection>
  </div>

  <div *ngIf="allowEdit" mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button mat-raised-button
                    type="submit" 
                    [disabled] = "!hasChanges"
                    [mat-dialog-close]="1" 
                    (click)="save()"
                    class="save-button mat-accent"
                    aria-label="SAVE">
                SAVE
            </button>
        </div>
    </div>
</div>
